
const CONTENT_COPY_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="{0}" height="{1}" fill="{2}">
<path d="M4 4V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-2v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2zm2 0h8a2 2 0 0 1 2 2v8h2V2H6v2zM2 6v12h12V6H2z"/>
</svg>
`

export {
    CONTENT_COPY_ICON
}
